function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 100 100"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M54.2 100C28.9 100 8.3 79 8.3 53.2S28.9 6.4 54.2 6.4s45.8 21 45.8 46.8V100zM12.4 0a34.3 34.3 0 00-6.7 5.2C3.4 7.4 1.5 9.9 0 12.6",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.4 31.4c-2 1.2-3.9 2.7-5.7 4.4q-2.85 2.7-4.8 6.3m39.3 18.7c-1.6 1-3.1 2.2-4.5 3.5-1.5 1.5-2.8 3.1-3.8 5",
  fill: "none"
}));